import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";
import AdminBookings from "@/pages/AdminBookings";
import Careers from "@/pages/Careers";
import CareersDriver from "@/pages/CareersDriver";
import CareersMonitor from "@/pages/CareersMonitor";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/service-area/:city" element={<CityPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/driver" element={<CareersDriver />} />
          <Route path="/careers/transportation-monitor" element={<CareersMonitor />} />
          <Route path="/admin" element={<AdminBookings />} />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
